import { createRoute } from '@tanstack/react-router';
import { loginParentRoute } from 'pages/shared/Login/loginParentRoute';

export const loginPhoneRoute = createRoute({
  getParentRoute: () => loginParentRoute,
  path: '/phone_number',
}).lazy(() =>
  import('pages/shared/Login/VerifyPhoneNumber/VerifyPhoneNumber').then((d) => d.Route)
);
